import { Button, Drawer, Grid } from '@mui/material'
import CustomButton from 'components/Button/CustomButton'
import { Link, NavLink, useLocation } from 'react-router-dom'
import logo1 from '/assets/logo/Mint-logo.png'
import { useAuth } from '../providers/AuthProvider'
import { useState, useEffect } from 'react'
import MenuIcon from 'components/Button/Menu'
import profilePicture from '/assets/Icon/profile.svg'
import ListItem from '@mui/material/ListItem'
import UserMenu from './UserMenu'
import discord from '/assets/Icon/Discord.svg'
import twitter from '/assets/Icon/Twitter.svg'
import instagram from '/assets/Icon/Instagram.svg'
import facebook from '/assets/Icon/Facebook.svg'
import youtube from '/assets/Icon/Youtube.svg'
import { clearNotifications, getNotifications } from 'utils/notifications'
import { Add } from '@mui/icons-material'
import Coach from 'components/DataDisplay/Coach'
import LiveBanner from 'components/Banner/LiveBanner'
import usePack from 'hooks/usePack'
import CountDown, { CountdownRenderProps } from 'react-countdown'
import { useWallets } from 'providers/WalletsProvider'
import useMarketplaceListing from 'hooks/useMarketplaceListing'
import ProductFeatureModal from 'module/productfeaturemodal/ProductFeatureModal'
import {
  aflMint2026ControlButtonTexts,
  aflMint2026FeatureModalData,
  aflMint2026FeatureModalLink
} from 'pages/main/TradePage/2026MintNotificationPopupData'
import { LS_KEY_FOR_COMPETITION_MODAL_DISMISSED } from 'module/competitionmodal/competition.constants'
import {
  migrationControlButtonTexts,
  migrationFeatureModalData,
  migrationFeatureModalLink
} from 'pages/main/TradePage/MigrationPopupData'

const Nav = () => {
  const { loggedIn, logIn, isDevLoggedIn, setIsDevLoggedIn, signUp } = useAuth()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [popupOpen, setPopupOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600)
  const { pack } = usePack(import.meta.env.VITE_CHAMPS_2023_4_ID)
  const isDropSoldOut =
    Number(pack?.maxSupply || 1) <= Number(pack?.issuedSupply || 0)
  const [isDropLive, setIsDropLive] = useState(
    new Date() > new Date(import.meta.env.VITE_COUNTDOWN_TIME)
  )
  const bannerName = 'competitionBanner'
  const [stickyMode, setStickyMode] = useState(
    localStorage.getItem(`bannerDismissed-${bannerName}`) ? false : true
  )
  const localDev = import.meta.env.VITE_DEV_ENVIRONMENT === 'true'
  // const [isBannerDismissed, setIsBannerDismissed] = useState(
  //   localStorage.getItem(`bannerDismissed-${bannerName}`)
  //   // true
  // )

  const [isBannerOpen, setIsBannerOpen] = useState<boolean>(
    // isDropLive && !isDropSoldOut && !isBannerDismissed
    // isConnected && flowWUSDCBalance > 0.0 ? true : false
    true
  )

  const { isMarketplaceSetup, setupMarketplace } = useMarketplaceListing()

  const setCompletedCountdown = ({
    completed
  }: CountdownRenderProps): React.ReactNode => {
    if (completed) {
      setIsDropLive(true)
    } else {
      return null
    }
  }

  // useEffect(() => {
  //   setIsBannerOpen(isConnected && !isMarketplaceSetup)
  // }, [isConnected, isMarketplaceSetup])

  // useEffect(() => {
  //   if (isDropLive && !isDropSoldOut && !isBannerDismissed) {
  //     setIsBannerOpen(true)
  //   }
  // }, [isDropLive, isDropSoldOut, isBannerDismissed])

  useEffect(() => {
    const changeColour = () => {
      if (window.scrollY >= 50 || isBannerOpen) {
        setStickyMode(true)
      } else {
        setStickyMode(false)
      }
    }
    window.addEventListener('scroll', changeColour)
    return () => {
      window.removeEventListener('scroll', changeColour)
    }
  }, [isBannerOpen])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setStickyMode(isBannerOpen ? true : false)
  }, [isBannerOpen])

  useEffect(() => {
    setNotificationMessage(getNotifications().newPacks ?? '')
  }, [location])

  const dismissNotifications = () => {
    clearNotifications()
  }

  return (
    <>
      <div
        className={`w-full transition-all duration-300 ${
          isBannerOpen ? 'h-[30px]' : 'h-0'
        }`}
      ></div>
      {/* <CountDown
        date={import.meta.env[`VITE_COUNTDOWN_TIME`]}
        renderer={setCompletedCountdown}
      /> */}
      <Grid
        container
        className={`fixed top-0 z-[90] items-center  ${
          stickyMode ? 'nav nav-bg' : 'nav'
        } ${isBannerOpen ? 'h-[110px]' : 'h-[80px]'} `}
      >
        {/* drop live banner */}
        <div
          className="flex w-full cursor-pointer items-center justify-center"
          // onClick={() => setPopupOpen(true)}
        >
          <LiveBanner
            bannerName={bannerName}
            notification={
              isMobile ? '2026 AFL Mint Update' : '2026 AFL Mint Update'
            }
            isBannerOpen={isBannerOpen}
            setIsBannerOpen={setIsBannerOpen}
            setPopupOpen={setPopupOpen}
          />
        </div>

        {/* regular menu */}
        <div
          className={`global-padding hidden w-full items-center justify-between pb-7 pt-6 text-sm font-bold tracking-widest lg:flex`}
        >
          <Grid item className=" w-52">
            <Link to="/">
              <img src={logo1} alt="AFL Mint Logo" className="w-52" />
            </Link>
          </Grid>
          <Grid item className="text-white">
            <NavLink to="/packs/" className="nav p-4 font-podium49">
              PACKS
            </NavLink>
            <NavLink to="/collections" className="nav p-4 font-podium49">
              COLLECTIONS
            </NavLink>
            {/* <a
              href="https://challenges.aflmint.com.au"
              className="nav p-4 font-podium49"
            >
              CHALLENGES
            </a> */}
            <a
              href="https://challenges.aflmint.com.au/predictions"
              className="nav p-4 font-podium49"
            >
              PREDICTIONS
            </a>
            {/* <NavLink to="/marketplace" className="nav p-4 font-podium49">
              MARKETPLACE
            </NavLink> */}
            {/* {loggedIn && (
              <NavLink
                to="/marketplace/my-listings"
                className="nav hidden p-4 font-podium49 lg:inline-block"
              >
                MY LISTINGS
              </NavLink>
            )} */}
            <NavLink
              to="/mint-guide"
              className="nav hidden p-4 font-podium49 xl:inline-block"
            >
              GUIDE
            </NavLink>
            {/* <NavLink to="/mint-rookies" className="p-4 font-podium49 nav">
              ROOKIES
            </NavLink> */}
            {/* {localDev === true && (
              <NavLink
              to="#"
              className="p-4 font-podium49 nav"
              onClick={() => {
                localStorage.setItem(
                  'devIsLoggedIn',
                  !isDevLoggedIn ? 'true' : 'false'
                  )
                  setIsDevLoggedIn(!isDevLoggedIn)
                  }}
                  >
                  DEV LOGIN/LOGOUT
                  </NavLink>
                  )} */}
            {loggedIn && (
              <>
                <NavLink
                  to="/trophy-cabinet"
                  className="nav relative p-4 font-podium49"
                  onClick={() => dismissNotifications()}
                >
                  TROPHY CABINET
                  {notificationMessage && (
                    <div
                      className={` absolute right-0 top-0 h-[18px] w-[18px] items-center justify-center rounded-[50%] bg-blue2 ${
                        stickyMode ? 'hidden' : 'flex '
                      }`}
                    >
                      <p className="text-center text-xs font-bold text-white">
                        {notificationMessage}
                      </p>
                    </div>
                  )}
                  {notificationMessage && (
                    <div
                      className={`absolute right-1/2 top-12 translate-x-[50%] ${
                        stickyMode ? 'hidden' : 'flex '
                      }`}
                      onClick={() => dismissNotifications()}
                    >
                      <Coach>
                        <div className="pb-4 font-inter text-[13px] leading-[18px] tracking-wide">
                          Your new item is now in your Trophy Cabinet
                        </div>
                        <div className="flex w-full justify-end">
                          <CustomButton
                            type="button"
                            model="secondary"
                            size="small"
                            variant="contained"
                            label="Take a look"
                          />
                        </div>
                      </Coach>
                    </div>
                  )}
                </NavLink>
              </>
            )}
          </Grid>
          {!loggedIn ? (
            <Grid item className="flex w-52 flex-row items-center justify-end">
              <button
                onClick={logIn}
                className="pr-5 font-podium49 tracking-widest text-white"
              >
                LOG IN
              </button>
              <CustomButton
                type="button"
                model="primary"
                variant="contained"
                label="SIGN UP"
                onClick={signUp}
                className="h-8 !font-podium49 uppercase !tracking-widest"
              />
            </Grid>
          ) : (
            <Grid item className="w-52">
              <UserMenu />
            </Grid>
          )}
        </div>
        {/* mobile menu */}
        <div
          className={`flex w-full items-center justify-between p-5 text-sm font-bold tracking-widest lg:hidden `}
        >
          <Drawer
            anchor="right"
            open={open}
            onClose={() => setOpen(false)}
            sx={{
              overflow: 'visible',
              '& .MuiPaper-root': {
                backgroundColor: 'transparent',
                overflowY: 'auto',
                overflowX: 'visible',
                boxShadow: 'none'
              }
            }}
            className="modal-bg"
          >
            <div className="flex h-full">
              <div
                onClick={() => setOpen(false)}
                className="flex h-[30px] w-[30px] cursor-pointer items-center justify-center bg-white"
              >
                <Add
                  fontSize="large"
                  style={{
                    transform: `rotate(45deg)`,
                    color: '#000000'
                  }}
                />
              </div>
              <div className="w-72 bg-black1">
                <div className="relative flex h-[80vh] flex-col justify-between pt-10 text-white">
                  <Grid>
                    <ListItem>
                      <NavLink
                        to="/packs/"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        PACKS
                      </NavLink>
                    </ListItem>
                    <ListItem>
                      <NavLink
                        to="/collections"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        COLLECTIONS
                      </NavLink>
                    </ListItem>
                    {/* <ListItem>
                      <a
                        href="https://challenges.aflmint.com.au"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        CHALLENGES
                      </a>
                    </ListItem> */}
                    <ListItem>
                      <a
                        href="https://challenges.aflmint.com.au/predictions"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        PREDICTIONS
                      </a>
                    </ListItem>
                    {/* <ListItem>
                      <NavLink
                        to="/marketplace"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        MARKETPLACE
                      </NavLink>
                    </ListItem> */}
                    {/* {loggedIn && (
                      <ListItem>
                        <NavLink
                          to="/marketplace/my-listings"
                          className="mb-3 font-podium49 tracking-wider"
                          onClick={() => setOpen(false)}
                          style={{ fontSize: '28px', lineHeight: '28px' }}
                        >
                          MY LISTINGS
                        </NavLink>
                      </ListItem>
                    )} */}
                    <ListItem>
                      <NavLink
                        to="/learn"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        LEARN
                      </NavLink>
                    </ListItem>
                    <ListItem>
                      <NavLink
                        to="/mint-guide"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        GUIDE
                      </NavLink>
                    </ListItem>
                    {/* <ListItem>
                      <NavLink
                        to="/mint-rookies"
                        className="mb-3 font-podium49 tracking-wider"
                        onClick={() => setOpen(false)}
                        style={{ fontSize: '28px', lineHeight: '28px' }}
                      >
                        ROOKIES
                      </NavLink>
                    </ListItem> */}
                    {loggedIn ? (
                      <ListItem>
                        <NavLink
                          to="/trophy-cabinet"
                          className="mb-3 font-podium49 tracking-wider"
                          onClick={() => setOpen(false)}
                          style={{ fontSize: '28px', lineHeight: '28px' }}
                        >
                          TROPHY CABINET
                        </NavLink>
                      </ListItem>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid>
                    {!loggedIn ? (
                      <Grid item>
                        <ListItem>
                          <button
                            onClick={() => {
                              logIn()
                              setOpen(false)
                            }}
                            className="text-sm font-bold tracking-wide"
                          >
                            Sign Up
                          </button>
                        </ListItem>
                        <ListItem>
                          <button
                            onClick={() => {
                              logIn()
                              setOpen(false)
                            }}
                            className="text-sm font-bold tracking-wide"
                          >
                            Log In
                          </button>
                        </ListItem>
                      </Grid>
                    ) : (
                      ''
                    )}
                    <ListItem>
                      <Link
                        to="/roadmap"
                        className=" text-sm font-bold tracking-wide"
                      >
                        Roadmap
                      </Link>
                    </ListItem>
                    <ListItem>
                      <a
                        className=" text-sm font-bold tracking-wide"
                        href="https://challenges.aflmint.com.au/support"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Help Centre
                      </a>
                    </ListItem>
                    <Grid
                      item
                      container
                      justifyContent="center"
                      className="p-2 "
                      columnSpacing={2}
                    >
                      <Grid item sx={{ py: '5px' }}>
                        <a
                          href="https://discord.com/invite/aflmintofficial"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={discord}
                            alt=""
                            className="social-icon-nav"
                          />
                        </a>
                      </Grid>
                      <Grid item sx={{ py: '5px' }}>
                        <a
                          href="https://twitter.com/aflmint"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={twitter}
                            alt=""
                            className="social-icon-nav"
                          />
                        </a>
                      </Grid>
                      <Grid item sx={{ py: '5px' }}>
                        <a
                          href="https://www.instagram.com/aflmint/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={instagram}
                            alt=""
                            className="social-icon-nav"
                          />
                        </a>
                      </Grid>
                      <Grid item sx={{ py: '5px' }}>
                        <a
                          href="https://www.youtube.com/channel/UCT1E0Rmm6_DY99dRTFI1hyQ"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={youtube}
                            alt=""
                            className="social-icon-nav"
                          />
                        </a>
                      </Grid>
                      <Grid item sx={{ py: '5px' }}>
                        <a
                          href="https://facebook.com/aflmint"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={facebook}
                            alt=""
                            className="social-icon-nav"
                          />
                        </a>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </Drawer>

          <Grid item className="w-36 xsm:w-52">
            <Link to="/">
              <img src={logo1} alt="AFL Mint Logo" />
            </Link>
          </Grid>
          <div className="flex">
            {!loggedIn ? (
              <Grid item className="flex flex-row items-center justify-center">
                <button
                  onClick={logIn}
                  className="mr-4 hidden font-podium49 tracking-widest text-white sm:block"
                >
                  LOG IN
                </button>
                <CustomButton
                  type="button"
                  model="primary"
                  variant="contained"
                  label="SIGN UP"
                  className="!hidden h-8 !font-podium49 uppercase !tracking-widest sm:!block"
                  onClick={logIn}
                />
                <button onClick={logIn}>
                  <img src={profilePicture} alt="" className="h-7 sm:hidden" />
                </button>
              </Grid>
            ) : (
              <Grid item>
                <UserMenu />
              </Grid>
            )}
            <button className="ml-2 sm:ml-4" onClick={() => setOpen(true)}>
              <MenuIcon fontSize="large" />
            </button>
          </div>
        </div>
      </Grid>
      {popupOpen && (
        <ProductFeatureModal
          featureModalData={migrationFeatureModalData}
          controlButtonTexts={migrationControlButtonTexts}
          featureModalLink={migrationFeatureModalLink}
          isBannerMode={true}
          popupOpen={popupOpen}
          setPopupOpen={setPopupOpen}
          localKey={'MigrationPopup'}
        />
      )}
    </>
  )
}

export default Nav
